import type { ReactElement } from "react"
import React, { Fragment } from "react"
import PlainLinkAtm from "@onestore/hel/dist/components/atoms/PlainLinkAtm"
import GridOrg from "@onestore/hel/dist/components/organisms/GridOrg"
import PushOrg from "@onestore/hel/dist/components/organisms/PushOrg"
import type { MarketplaceSitemapQuery } from "@gatsby-plugin-generic-page/hooks/useMarketplaceSitemapQuery"

type MarketplacePagesByCategoryNameType = {
  [key: string]: MarketplaceSitemapQuery[]
}

type SitemapSectionProps = {
  marketplacePages: MarketplaceSitemapQuery[]
}

const MarketplaceSitemap = ({
  marketplacePages,
}: SitemapSectionProps): ReactElement<SitemapSectionProps> => {
  const marketplaceProductsByCategoryName: MarketplacePagesByCategoryNameType =
    marketplacePages.reduce((result, product) => {
      const categoryName = product.flatData.primaryCategory[0].flatData.name

      if (!result[categoryName]) {
        result[categoryName] = []
      }
      result[categoryName].push(product)

      return result
    }, {})

  const marketplacePagesLength =
    marketplacePages.length +
    Object.keys(marketplaceProductsByCategoryName).length

  return (
    <GridOrg
      columns={{ small: 1, medium: 2, large: 3 }}
      rows={{
        small: marketplacePagesLength,
        medium: Math.ceil(marketplacePagesLength / 2),
        large: Math.ceil(marketplacePagesLength / 3),
      }}
      autoFlow={{ small: "row", medium: "column", large: "column" }}
      gutterSpace={{
        small: 1,
        medium: { x: 3, y: 1 },
        large: { x: 4.5, y: 1 },
      }}
    >
      {Object.entries(marketplaceProductsByCategoryName).map(
        ([categoryName, marketplacePage]) => (
          <Fragment key={categoryName}>
            <PlainLinkAtm
              title={categoryName}
              typography="small4"
              type="underline"
              emphasis="half"
              to={
                marketplacePage[0].flatData.primaryCategory[0].flatData.pages[0]
                  .flatData.url
              }
            >
              • {categoryName}
            </PlainLinkAtm>

            {marketplacePage.map((page: MarketplaceSitemapQuery) => (
              <PushOrg key={page.flatData.name} leftSpace={2} hasNoReset>
                <PlainLinkAtm
                  title={page.flatData.name}
                  typography="small2"
                  type="underline"
                  emphasis="half"
                  to={page.flatData.pages[0].flatData.url}
                >
                  • {page.flatData.name}
                </PlainLinkAtm>
              </PushOrg>
            ))}
          </Fragment>
        )
      )}
    </GridOrg>
  )
}

export default MarketplaceSitemap
